import { Container, Modal, Row, Col } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';

export type ConfirmChangesModalProps = {
  showConfirmChangesModal: boolean;
  currentStep: number;
  goToStep: () => void;
  handleCloseConfirmChangesModal: () => void;
};

const ConfirmChangesModal = ({
  showConfirmChangesModal,
  currentStep,
  goToStep,
  handleCloseConfirmChangesModal,
}: ConfirmChangesModalProps) => {
  return (
    <>
      <Modal
        className={'confirm-changes-modal lh-xs'}
        show={showConfirmChangesModal}
        onHide={handleCloseConfirmChangesModal}
      >
        <Modal.Header className={'border-0'} closeButton>
          <Modal.Title className={' ms-auto h6 fw-normal'}>
            Confirm changes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col>
                <p className={'text-center mb-0 text-fs-6'}>
                  Are you sure you want to go back to{' '}
                  <span className={'fw-bold'}>{`“step ${
                    currentStep + 1
                  }”`}</span>
                  ?
                </p>
                <p className={'text-center text-fs-6 mb-0'}>
                  You can’t undo this action
                </p>
              </Col>
            </Row>
            <Row className={'px-4 py-9'}>
              <Col>
                <Blockquote lineVariant="warning" variant={'warning-bg'}>
                  <p className={'mb-0'}>Warning?</p>
                  <p className={'mb-0 '}>
                    Every entry after this step will be cleared and you will
                    have to refill your selections/entries
                  </p>
                </Blockquote>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-1'}>
          <Button
            className={'mt-4 mt-lg-0'}
            variant={'primary-outline'}
            onMouseDown={handleCloseConfirmChangesModal}
          >
            Cancel
          </Button>
          <Button
            className={'order-1 order-lg-3'}
            size={'lg'}
            onMouseDown={goToStep}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmChangesModal;
